



















import Vue from 'vue';

// Types
import { CandidateJobBuilderChangeEvent, commonProps, setupBuilder } from '~/utils/candidate';
import { CandidateJobBuilder } from '~/utils/candidate/CandidateJobBuilder';
import CandidateService from '~/services/CandidateService';

// Components
import WorkExperienceForm from '../forms/WorkExperienceForm.vue';
import ProfileModal from './ProfileModal.vue';

export default Vue.extend({
    name: 'WorkExperienceModal',
    components: { ProfileModal, WorkExperienceForm },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        ...commonProps(),
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),

            isLoading: false,
            isFormValid: true,
            hasUnsavedChanges: false,
        };
    },
    computed: {
        saveDisabled(): boolean {
            return !this.hasUnsavedChanges || !this.isFormValid;
        },
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty;
        },
        handleSave() {
            if (!this.builder || this.builder.isEmpty()) return;
            const request = this.builder.buildRequest();
            this.isLoading = true;
            this.service
                .updateCandidateProfile(request)
                .then(() => {
                    this.isLoading = false;
                    this.$emit('close');
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
    },
    mounted() {
        const builder = setupBuilder.apply(this);
        builder.on('change', this.handleBuilderChange);
    },
    beforeDestroy() {
        if (this.builder) this.builder.off('change', this.handleBuilderChange);
    },
});
